import { useSelector } from "react-redux";
import { RootState } from "@/store/store";
import {
  canFundOrDeclineFromFinal,
  canSendMerchantTasks,
  hasCapability,
  isFunderStaff,
  isOrgManager,
  isStaffUser,
  isSystemAdmin,
  isTrueAdmin,
  isUnderwritingActor,
  type MerchantSendOrgSettings,
} from "@/auth/capabilities";

export function useCurrentUser() {
  const { user, isAuthenticated, loading, sessionChecked } = useSelector(
    (state: RootState) => state.auth
  );
  const userRole = user?.role ?? null;

  return {
    user,
    isAuthenticated,
    loading,
    sessionChecked,
    userRole,
    hasCapability: (roles: readonly string[]) => hasCapability(user, roles),
    isTrueAdmin: isTrueAdmin(user),
    isOrgManager: isOrgManager(user),
    isFunderStaff: isFunderStaff(user),
    isUnderwritingActor: isUnderwritingActor(user),
    isStaffUser: isStaffUser(user),
    isSystemAdmin: isSystemAdmin(user),
    canFundOrDeclineFromFinal: canFundOrDeclineFromFinal(user),
    /** The user's primary organization, shown as the portal name. */
    portalName:
      user?.organization_name || (isFunderStaff(user) ? "Funder Portal" : "Broker Portal"),
    canSendMerchantTasks: (orgSettings: MerchantSendOrgSettings | null | undefined) =>
      canSendMerchantTasks(user, orgSettings),
    /**
     * @deprecated Use ``isFunderStaff``. Kept for call sites that treated
     * "admin" as admin-or-underwriter funder portal access.
     */
    isAdmin: isFunderStaff(user),
  };
}
